/*
  Página de favoritos.

  La lista solo existe para quien ha iniciado sesión, así que el servidor ya
  la pinta entera. Aquí solo se retiran las tarjetas que se desmarcan, sin
  recargar, y se ajusta el estado vacío.
*/
(() => {
  const pagina = document.querySelector('[data-wishlist-pagina]');
  if (!pagina) return;

  const rejilla = pagina.querySelector('[data-wishlist-rejilla]');
  const vacio = pagina.querySelector('[data-wishlist-vacio]');
  if (!rejilla) return;

  const mostrar = (nodo, si) => {
    if (!nodo) return;
    nodo.hidden = !si;
    nodo.classList.toggle('hidden', !si);
  };

  const ajustarEstados = () => mostrar(vacio, rejilla.children.length === 0);

  // Se espera un momento antes de quitar la tarjeta: así se ve el corazón
  // vaciarse antes de que el hueco se cierre.
  document.addEventListener('wishlist:cambio', (evento) => {
    const vivos = new Set(((evento.detail && evento.detail.items) || []).map((i) => i.id));

    rejilla.querySelectorAll('[data-wishlist-item]').forEach((item) => {
      if (vivos.has(item.dataset.wishlistItem)) return;
      if (item.classList.contains('wishlist-pagina__item--saliendo')) return;

      item.classList.add('wishlist-pagina__item--saliendo');
      setTimeout(() => {
        item.remove();
        ajustarEstados();
      }, 250);
    });
  });

  ajustarEstados();
})();
